import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';
import { computed } from 'vue';

import {
  IonContent,
  IonGrid,
  IonRow,
  IonIcon,
  IonButton,
  modalController,
} from '@ionic/vue';

import { IChoice } from '@/support/models/choice.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuizResultModal',
  props: {
    selected: null,
    answers: null
  },
  setup(__props: any) {

const props = __props as { selected: IChoice[]; answers: string[] }



const isCorrect = computed(() =>
  props.selected.length > 0
    ? props.selected.every((choice) => props.answers?.includes(choice.value))
    : false
);

const title = isCorrect.value ? 'Correct' : 'Incorrect';
const icon = isCorrect.value ? checkmarkCircleOutline : closeCircleOutline;

const text = isCorrect.value
  ? 'Your answer was correct'
  : `Correct Answer: ${props.answers.join(',')}`;

const closeModal = () => {
  return modalController.dismiss(null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), { class: "ion-justify-content-between" }, {
            default: _withCtx(() => [
              _createElementVNode("h2", null, _toDisplayString(_unref(title)), 1),
              _createVNode(_unref(IonIcon), {
                class: _normalizeClass({ success: _unref(isCorrect), error: !_unref(isCorrect) }),
                icon: _unref(icon)
              }, null, 8, ["class", "icon"]),
              _createElementVNode("p", null, _toDisplayString(_unref(text)), 1),
              _createVNode(_unref(IonButton), {
                expand: "full",
                onClick: closeModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Continue")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})